export default {
  data() {
    return {
      invoice: "1",
      discountTabs: "1",
      invoiceActive: 2,
      discountActive: "1",
      invoiceForm: {
        id: "",
        tel: "",
        name: "",
        bank: "",
        address: "",
        account: "",
      },
      invoiceRules: {
        id: [{ required: true, message: "请填写个人或企业名称", trigger: "blur" }],
        name: [{ required: true, message: "请填写个人或企业名称", trigger: "blur" }],
      },
      invoiceVisible: false,
      invoiceListVisible: false,
      shippingAddressVisible: false,
    };
  },

  methods: {
    invoiceChange(type) {
      this.invoiceActive = type;
    },

    submitInvoiceForm() {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          console.log("submit!");
        } else {
          console.log("error submit!!");
        }
      });
    },
  },
};
